import { ApiService } from 'react-angle-dashboard-components'

export interface IGetEligibilityInfoReqBody {
  first_name: string
  last_name: string
  date_of_birth: string
  member_id: string
  date_of_service?: string
}

export interface IBenefitSubcategory {
  sub_category: string
  in_network_sub: string
  in_network_main: string
  out_network_sub: string
  out_network_main: string
  modal_description: string
  inline_description: string
}

export interface EligibilityResult {
  plan: {
    rx_bin: string
    rx_pcn: string
    rx_group: string
    plan_id: string
    plan_name: string
    eligible_member_types: string[]
    dependent_child_age_limit: number
    dependent_child_term_rule: string
    is_hdhp: boolean
    line_of_coverage: string
    plan_type: string
    start_date: string
    end_date: string
    metal_tier: string
    plan_year: number
    sbc_url: string
    sob_url: string
    deductible_individual_inn: number
    deductible_family_inn: number
    deductible_individual_oon: number
    deductible_family_oon: number
    deductible_rx_inn: number
    deductible_rx_oon: number
    deductible_type: number
    oop_max_individual_inn: number
    oop_max_family_inn: number
    oop_max_individual_oon: number
    oop_max_family_oon: number
    doctor_visit_inn_copay_type: string
    doctor_visit_inn_after_deductible: boolean
    doctor_visit_inn_copay: string
    doctor_visit_inn_coinsurance: string
    doctor_visit_oon_copay_type: string
    doctor_visit_oon_after_deductible: boolean
    doctor_visit_oon_copay: String
    doctor_visit_oon_coinsurance: number
    urgent_care_inn_copay_type: string
    urgent_care_inn_after_deductible: boolean
    urgent_care_inn_copay: number
    urgent_care_inn_coinsurance: string
    urgent_care_oon_copay_type: string
    urgent_care_oon_after_deductible: boolean
    urgent_care_oon_copay: string
    urgent_care_oon_coinsurance: number
    specialist_inn_copay_type: string
    specialist_inn_after_deductible: boolean
    specialist_inn_copay: number
    specialist_inn_coinsurance: string
    specialist_onn_copay_type: string
    specialist_onn_after_deductible: boolean
    specialist_onn_copay: string
    specialist_onn_coinsurance: number
    telehealth_inn_copay_type: string
    telehealth_inn_after_deductible: boolean
    telehealth_inn_copay: number
    telehealth_inn_coinsurance: string
    telehealth_oon_copay_type: string
    telehealth_oon_after_deductible: boolean
    telehealth_oon_copay: string
    telehealth_oon_coinsurance: string
    rx_1: 5
    rx_1_inn_copay_type: string
    rx_1_inn_after_deductible: boolean
    rx_1_inn_copay: 5
    rx_1_inn_coinsurance: string
    rx_2: 15
    rx_2_inn_copay_type: string
    rx_2_inn_after_deductible: boolean
    rx_2_inn_copay: 15
    rx_2_inn_coinsurance: string
    rx_3: 25
    rx_3_inn_copay_type: string
    rx_3_inn_after_deductible: boolean
    rx_3_inn_copay: 25
    rx_3_inn_coinsurance: string
    benefits: [
      {
        sub_categories: IBenefitSubcategory[]
        top_level_name: string
      }
    ]
    pediatric_vision_dental: boolean
    pediatric_vision: boolean
    pediatric_dental: boolean
    adult_vision: boolean
    vba_plan_id_name: string
    vba_plan_name: string
    mrx_plan_name: string
    mrx_tier: string
    mrx_md_rx_combined: boolean
    id_card_plan_name: string
    id_card_name: string
    centivo_plan_name: string
  }
  network: string
  active: boolean
  effective_date: string
  term_date: string
  deductible_individual_inn: number
  deductible_family_inn: number
  deductible_individual_oon: number
  deductible_family_oon: number
  rx_deductible_individual_inn: number
  rx_deductible_family_inn: number
  rx_deductible_individual_oon: number
  rx_deductible_family_oon: number
  oop_individual_inn: number
  oop_family_inn: number
  oop_individual_oon: number
  oop_family_oon: number
  member: {
    member_id: string
    name: {
      title: string
      first_name: string
      middle_name: string
      last_name: string
      suffix: string
    }
    date_of_birth: string
  }
}

export class EligibilityService extends ApiService {
  async getEligibilityInfo(data: IGetEligibilityInfoReqBody) {
    return this.request({
      method: 'post',
      url: '/public/eligibility-search',
      data
    }).then((r: any) => r)
  }

  async createTicket(data: FormData): Promise<any> {
    return this.request({
      method: 'post',
      url: '/public/eligibility-search/create-ticket',
      headers: {
        'Content-Type':
          'multipart/form-data; boundary=20639c8395c2a499779e9ec7758bbbe6'
      },
      data
    })
  }
}
